module.exports = __webpack_public_path__ + "img/material_bus.da8cf54e.svg";